<template src="./Search.html"></template>
<style lang="scss" scoped src="./Search.scss"></style>

<script>

import Api from "@/api/Api";
import {clickOutside} from '@storefront-ui/vue/src/utilities/directives/click-outside/click-outside-directive.js';
import {OrkLoader, OrkProductCart} from "@/components/Ork";
import {
  SfCheckbox,
  SfRange,
  SfRadio,
  SfNotification,
  SfPagination,
  SfBreadcrumbs,
  SfDivider,
  SfHeading,
  SfSelect,
  SfButton,
  SfImage,
  SfIcon,
  SfScrollable,
  SfAccordion,
  SfSidebar,
  SfLoader,
  SfSearchBar,
  SfBar
} from '@storefront-ui/vue';
import ProductOptions from "@/utils/product_options";
import {LightProduct} from "@/models/product";
import {Pagination} from "@/models/pagination";
import SearchAutocomplete from '@/components/SearchAutocomplete';
import {icons} from "@/utils/icons";
import GtagEvent from "@/utils/GtagEvent";

export default {
  name: 'Search',
  data() {
    return {
      hasInfiniteScroll: false,
      hasAutoLoad: false,
      loadingNext: false,
      icons: icons,
      products: null,
      loading: false,
      notFirst: false,
      error: null,
      pagination: Pagination.of(null),
      sortBy: {options: ProductOptions.getProductOptions.sortAttributes, selected: process.env.VUE_APP_DEFAULT_SORT},
      sortOption: ProductOptions.getProductOptions.sortAttributes,
      currentPage: this.$router.history.current.query.page || 1,
      totalPages: null,
      breadcrumbs: [],
      searchTerm: null,
      searchTermFirst: null,
      searchTerms: [],
      showAutocomplete: false,
      debounceSearch: null,
      loadingSearch: false,
      loadingSearchFirst: false,
      loadingSearchNoResult: false,
      scrollPosition: null,
    };
  },
  directives: {clickOutside},
  components: {
    SfBar,
    SfCheckbox,
    SfAccordion,
    SfRadio,
    SfSearchBar,
    SearchAutocomplete,
    OrkProductCart,
    SfHeading,
    SfBreadcrumbs,
    SfPagination,
    SfButton,
    SfScrollable,
    SfImage,
    SfIcon,
    SfSelect,
    OrkLoader,
    SfDivider,
    SfSidebar,
    SfRange,
    SfLoader,
    SfNotification
  },
  computed: {},
  created() {
    this.hasAutoLoad = eval(process.env.VUE_APP_CATEGORIES_AUTOLOAD);
    this.hasInfiniteScroll = eval(process.env.VUE_APP_CATEGORIES_INFINITESCROLL);

    this.searchTerm = this.$router.history.current.query.searchTerm
    this.filters = this.$router.history.current.query.filters
    this.setBreadcrumbs()
    if(this.$router.history.current.query.page){

      this.reloadSearchProducts()
    }
    else {
      this.searchProducts();
    }
  },

  watch: {
    $route: 'searchProducts'
  },
  mounted() {
    window.addEventListener('scroll', this.updateScroll);
    if (this.hasInfiniteScroll && this.hasAutoLoad) {
      window.onscroll = () => {
        let bottomOfWindow = document.documentElement.scrollTop + window.innerHeight === document.documentElement.offsetHeight;
        if (bottomOfWindow) {
          this.loadNextProduct()
        }
      };
    }
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.updateScroll);
  },
  methods: {
    loadNextProduct() {
      const query = {...this.$router.history.current.query}
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
        query.page = this.currentPage
        this.$router.replace({query: {...query}})
      }
    },
    updateScroll() {
      this.scrollPosition = window.scrollY;
      if (this.scrollPosition > 30) {
        document.body.classList.add("notTop");
      } else {
        document.body.classList.remove("notTop");
      }
    },
    setBreadcrumbs() {

      this.breadcrumbs = [{
        text: this.$i18n.t('Home'),
        link: '/'
      }, {
        text: this.$i18n.t('Search'),
        link: '/recherche'
      }];

    },
    getLengthTerm(term) {
      let lengthTerm = 0;
      for (var i = 0, len = term.length; i < len; i++) {
        if (term[i] !== ' ')
          lengthTerm++;
      }
      return lengthTerm;
    },
    handleSearchAutoComplete(term) {

      clearTimeout(this.debounceSearch);
      this.searchTerm = term;
      if (this.getLengthTerm(this.searchTerm) >= 3) {

        this.debounceSearch = setTimeout(() => {
          this.loadingSearch = true;
          Api.product.searchAutocomplete(term).then((data) => {
            this.showAutocomplete = true;
            this.searchTerms = data;
          }).catch((e) => {
            this.$store.dispatch('sendNotification', {
              type: 'danger',
              message: this.$i18n.t('server error'),
              icon: icons.error
            });
          }).finally(() => {
            this.loadingSearch = false;
          })
        }, 300);
      }

    },
    handleNoResultSearchAutoComplete(term) {

      clearTimeout(this.debounceNoResultSearch);
      this.searchTerm = term;
      if (this.getLengthTerm(this.searchTerm) >= 3) {

        this.debounceNoResultSearch = setTimeout(() => {
          this.loadingSearchNoresult = true;
          Api.product.searchAutocomplete(term).then((data) => {
            this.showAutocomplete = true;
            this.searchTerms = data;
          }).catch((e) => {
            this.$store.dispatch('sendNotification', {
              type: 'danger',
              message: this.$i18n.t('server error'),
              icon: icons.error
            });
          }).finally(() => {
            this.loadingSearchNoresult = false;
          })
        }, 300);
      }

    },
    closeAutocomplete() {
      this.showAutocomplete = false;
    },
    handleFirstSearchAutoComplete(term) {
      clearTimeout(this.debounceFirstSearch);

      this.searchTermFirst = term;

      if (this.getLengthTerm(this.searchTermFirst) >= 3) {
        this.debounceFirstSearch = setTimeout(() => {
          this.loadingSearchFirst = true;
          Api.product.searchAutocomplete(term).then((data) => {
            this.showAutocomplete = true;
            this.searchTerms = data;
          }).catch((e) => {
            this.$store.dispatch('sendNotification', {
              type: 'danger',
              message: this.$i18n.t('server error'),
              icon: icons.error
            });
          }).finally(() => {
            this.loadingSearchFirst = false;

          })
        }, 300);
      }
    },
    changeSearchTerm(term) {
      this.searchTerm = term;
      this.showAutocomplete = false;
      this.notFirst = true
      if (this.getLengthTerm(this.searchTerm) >= 3) {
        this.$router.replace({query: {searchTerm: this.searchTerm}}).catch(() => {
          GtagEvent.search(this.searchTerm)
          return null
        });
      }
      this.searchTerms = []
    },
    changeSorting(sort) {
      this.sortBy.selected = sort;
      ProductOptions.changeSorting(sort);
    },

    changeItemsPerPage(itemsPerPage) {
      this.pagination.itemsPerPage = parseInt(itemsPerPage);
      ProductOptions.changeItemsPerPage(itemsPerPage);
    },
    searchProducts() {

      this.searchTerm = this.$router.history.current.query.searchTerm || null;
      if (this.searchTerm && this.getLengthTerm(this.searchTerm) >= 3) {

        if (this.$router.history.current.query.page) {
          this.loadingNext = true;
        } else {
          this.loadingSearch = true;
        }
        let content = [];


        Api.product.searchPage(this.$router.history.current.query)
            .then(data => {
              this.pagination = Pagination.of(data.products);
              this.totalPages = data.products.totalPages;
              for (let lightProduct of data.products.content) {
                content.push(LightProduct.of(lightProduct));
              }

                this.products = content;

            })
            .catch((e) => {
              this.error = e;
            })
            .finally(() => {
                  this.notFirst = true;
                  if (this.$router.history.current.query.page) {
                    this.loadingNext = false;
                  } else {
                    this.loadingSearch = false;
                  }
                }
            );
      } else {
        this.notFirst = false;
        this.searchTerm = null;
        this.searchTermFirst = null;
        this.products = null;
      }
    },

    reloadSearchProducts() {

      this.searchTerm = this.$router.history.current.query.searchTerm || null;
      if (this.searchTerm && this.getLengthTerm(this.searchTerm) >= 3) {
        this.loadingSearch = true;
        let content = [];


        Api.product.reloadSearchPage(this.$router.history.current.query)
            .then(data => {
              this.pagination = Pagination.of(data.products);
              this.totalPages = data.products.totalPages;
              for (let lightProduct of data.products.content) {
                content.push(LightProduct.of(lightProduct));
              }

              if (this.products) {
                let products = [...this.products, ...content]
                this.products = products
              } else {
                this.products = content;
              }
            })
            .catch((e) => {
              this.error = e;
            })
            .finally(() => {
                  this.notFirst = true;
                  this.loadingSearch = false;
                }
            );
      } else {
        this.notFirst = false;
        this.searchTerm = null;
        this.searchTermFirst = null;
        this.products = null;
      }
    },
  }

};
</script>

